import { gql } from 'graphql-request';

export const FETCH_COLLECTION_QUERY = gql`
  query ($id: ID!, $filter: CollectionFilter!) {
    collection(id: $id, filter: $filter) {
      __typename
      id
      title
      originalTitle
      description
      image {
        list
        cover
        listClean
        sticker
        svodCover
        appCover
        channelSquare
        channelList
        square
        portrait
        logo
        verticalBanner
        mobileBanner
        desktopBanner
        banner4k
      }
      tags
      rails {
        id
        title
        originalTitle
        image {
          list
          cover
          listClean
          sticker
          svodCover
          appCover
          channelSquare
          channelList
          square
          portrait
          logo
          verticalBanner
          mobileBanner
          desktopBanner
        }
        genres {
          id
          value
        }
        tags
        slug
        position
        contents {
          ... on Movie {
            id
            title
            originalTitle
            duration
            contentOwner
            businessType
            genres {
              id
              value
            }
            languages
            description
            assetType
            assetSubType
            releaseDate
            image {
              list
              cover
              listClean
              sticker
              svodCover
              appCover
              appSvodCover
              channelSquare
              channelList
              square
              portrait
              logo
              verticalBanner
              mobileBanner
              desktopBanner
              banner4k
              portraitClean
              tvCover
              mainThumbnail
            }
            actors
            ageRating
            audioLanguages
            subtitleLanguages
            eventLive
            tags
            introStartTime
            introEndTime
            billingType
            tier
            playDate
            seoTitle
            slug
            webUrl
            rating
            playedDuration
            video {
              isDrm
              url
              hlsUrl
              drmKey
            }
            contentPartner {
              id
              name
              image {
                rectangleDarkLogo
                rectangleWhiteLogo
                circleDarkLogo
                circleWhiteLogo
                purchaseImage
              }
              deeplinkUrl
            }
            relatedContentIds {
              id
            }
          }
          ... on Episode {
            id
            title
            originalTitle
            duration
            contentOwner
            businessType
            genres {
              id
              value
            }
            languages
            description
            assetType
            assetSubType
            releaseDate
            image {
              list
              cover
              listClean
              sticker
              svodCover
              appCover
              appSvodCover
              channelSquare
              channelList
              square
              portrait
              logo
              verticalBanner
              mobileBanner
              desktopBanner
              banner4k
              portraitClean
              tvCover
              mainThumbnail
            }
            actors
            ageRating
            audioLanguages
            subtitleLanguages
            eventLive
            tags
            introStartTime
            introEndTime
            episodeNumber
            billingType
            tier
            playDate
            seoTitle
            slug
            webUrl
            rating
            playedDuration
            contentPartner {
              name
            }
            video {
              url
              hlsUrl
              drmKey
              isDrm
            }
            tvShow {
              id
              title
              assetSubType
              originalTitle
            }
          }
        }
        nextUrl
        page
        size
        totalResults
      }
      page
      size
      totalResults
      contentPartner {
        id
        name
        image {
          rectangleDarkLogo
          rectangleWhiteLogo
          circleDarkLogo
          circleWhiteLogo
          purchaseImage
        }
        deeplinkUrl
      }
    }
  }
`;
